import apiService from './api';

export interface ScheduledEvent {
  id: string;
  title: string;
  description: string | null;
  project_id: string | null;
  assignee_id: string | null;
  due_at: string;
  frequency: string;
  status: string;
  category: string | null;
  nag_enabled: boolean;
  nag_level: string;
  nag_count: number;
  last_nagged_at: string | null;
  tags: string[];
  completed_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface CreateEventData {
  title: string;
  description?: string;
  project_id?: string;
  assignee_id?: string;
  due_at: string;
  frequency: string;
  category?: string;
  nag_enabled?: boolean;
  nag_channels?: string[];
  nag_interval_hours?: number;
  escalate_after_nags?: number;
  tags?: string[];
}

export interface UpdateEventData {
  title?: string;
  description?: string;
  assignee_id?: string;
  due_at?: string;
  status?: string;
  nag_enabled?: boolean;
  nag_interval_hours?: number;
  category?: string;
  tags?: string[];
}

export interface UpcomingDay {
  date: string;
  events: ScheduledEvent[];
}

class ScheduleService {
  async getEvents(params?: Record<string, string>): Promise<{ data: ScheduledEvent[]; total: number }> {
    const query = params ? '?' + new URLSearchParams(params).toString() : '';
    return apiService.get(`/schedule${query}`);
  }

  async getEvent(id: string): Promise<ScheduledEvent> {
    return apiService.get<ScheduledEvent>(`/schedule/${id}`);
  }

  async createEvent(data: CreateEventData): Promise<ScheduledEvent> {
    return apiService.post<ScheduledEvent>('/schedule', data);
  }

  async updateEvent(id: string, data: UpdateEventData): Promise<ScheduledEvent> {
    return apiService.patch<ScheduledEvent>(`/schedule/${id}`, data);
  }

  async completeEvent(id: string): Promise<ScheduledEvent> {
    return apiService.post<ScheduledEvent>(`/schedule/${id}/complete`);
  }

  async getUpcoming(days: number = 14): Promise<UpcomingDay[]> {
    return apiService.get<UpcomingDay[]>(`/schedule/upcoming?days=${days}`);
  }

  async getOverdue(): Promise<ScheduledEvent[]> {
    return apiService.get<ScheduledEvent[]>('/schedule/overdue');
  }

  async runNagCheck(): Promise<{ nags_sent: number; details: any[] }> {
    return apiService.post('/schedule/nag-run');
  }
}

export const scheduleService = new ScheduleService();
export default scheduleService;
